import { useQuery, QueryClient } from "@tanstack/react-query";
import api from "../../services/api";
import { queryKeys } from "../api/queryKeys";

interface ProductInfo {
  ds_apresentacao: string;
  full_cd_mercadoria: string;
  infos: {
    qt_fisica: number;
    qt_reservada: number;
  };
}

export const useProductByEan = (ean: string, enabled: boolean = true) => {
  return useQuery<ProductInfo>({
    queryKey: queryKeys.productByEan(ean),
    queryFn: async () => {
      const response = await api.get<ProductInfo>(`/products/${ean}`);
      return response.data;
    },
    enabled: enabled && !!ean,
  });
};

// Função helper para buscar produto imperativamente (usado em Promise.all)
export const fetchProductByEan = async (
  queryClient: QueryClient,
  ean: string
): Promise<ProductInfo> => {
  return queryClient.fetchQuery({
    queryKey: queryKeys.productByEan(ean),
    queryFn: async () => {
      const response = await api.get<ProductInfo>(`/products/${ean}`);
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
  });
};
